import { Box } from "@/Components/v2/atoms/Box";
import { ActionPlanStatusMapping, getActionPlanStatusText } from "../../action-plans/types";
import { HIDE_DECIMAL, useConfig } from "@/hooks/useConfig";
import { styled, Typography as MuiTypography } from "@mui/material";
import { Typography } from "@/Components/v2/atoms/Typography";
import { Stack } from "@/Components/v2/atoms/Stack";
import { ActionPlanStatus } from "@mutiny-group/sbo-openapi-client";

const IconWrapper = styled("span")<{ color: string }>(({ color }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "18px",
  height: "18px",
  lineHeight: 0,
  "& svg": {
    fontSize: "18px",
    color: color,
  },
}));

type StatusBannerProps = {
  status: ActionPlanStatus;
  currentRevenueDifference: number;
};

const StatusBanner = ({ status, currentRevenueDifference }: StatusBannerProps) => {
  const { config } = useConfig();
  const { label, style } = ActionPlanStatusMapping[status];
  const Icon = style.icon;

  const text = getActionPlanStatusText(
    status,
    config.currency.formatCurrency(Math.abs(currentRevenueDifference ?? 0), HIDE_DECIMAL)
  );

  return (
    <Box border={`1px solid ${style.color}`} borderRadius={1} px={3} py={2.5}>
      <Stack direction="row" spacing={1} alignItems="center" mb={text ? 1 : 0}>
        {Icon && (
          <IconWrapper color={style.color}>
            <Icon />
          </IconWrapper>
        )}
        <MuiTypography fontSize={14} fontWeight={600} color={style.color}>
          This plan is currently {label}
        </MuiTypography>
      </Stack>
      <Box pl={3.25}>
        {text && (
          <Typography fontSize={14} maxWidth={960}>
            {text}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default StatusBanner;
